export const settings = {
  default: {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    spaceBetween: 0,
    allowTouchMove: true,
  },

  onMethodsExample: {
    onInit: function () {},
    onSlideChange: function (swiper, readIndex, arrayLength) {
      console.log('Получить данные', swiper, readIndex, arrayLength);
    },
  },

  customPaginationExample: {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    pagination: {
      clickable: true,
      renderBullet: function (index, className) {
        return '<div class="' + className + '"><p>' + index + '</p></div>';
      },
    },
  },

  previewPrize: {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    spaceBetween: 0,
    speed: 500,
    allowTouchMove: false,
    autoplay: {
      delay: 2500,
    },
  },

  slideModalCarousel: [
    {
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: false,
      effect: 'fade',
      autoHeight: true,
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: '.slide-modal__pagination_1',
        clickable: true,
      },
    },
    {
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: false,
      effect: 'fade',
      autoHeight: true,
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: '.slide-modal__pagination_2',
        clickable: true,
      },
    },
  ],

  slideModalCarousel2: {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: false,
    effect: 'fade',
    autoHeight: true,
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.slide-modal__pagination',
      clickable: true,
    },
  },

  wishElf: {
    watchOverflow: true,
    slidesPerView: 'auto',
    pagination: {
      el: `.wish__content-pagination`,
      clickable: true,
    },
    navigation: {
      prevEl: '.wish__content-nav_prev',
      nextEl: '.wish__content-nav_next',
    },
  },
};
